import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { KeyboardArrowLeft } from '@material-ui/icons';
import { convertToRaw } from 'draft-js';
import { inject } from 'mobx-react';
import { WithSnackbarProps } from 'notistack';
import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import * as Yup from 'yup';
import { FormField } from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import DeglawyFeaturedPreview from './DeglawyFeaturedPreview/DeglawyFeaturedPreview';
import {
  getDropdownLanguagesList,
  languageCodes,
} from '../../constants/languages';
import { translate } from '../../helperFunctions/translation';
import {
  DeglawyFeatured,
  IDeglawyFeaturedStore,
} from '../../mobx-store/storeInterfaces/delawyFeaturedInterface';
import classes from './addEditDeglawyFeatured.module.scss';
import parse from 'html-react-parser';
import draftToHtml from 'draftjs-to-html';
interface IProps extends WithSnackbarProps {
  deglawyFeaturedStore: IDeglawyFeaturedStore;
  match: any;
  history: any;
}

interface IState {
  points: string;
  preview: string;
  title: string;
  descrpriton: string;
  formFields: FormField[];
  loading: boolean;
  selectedLang: string;
  processing: boolean;
}

@inject('deglawyFeaturedStore')
class AddEditDeglawyFeatured extends Component<
  IProps & RouteComponentProps,
  IState
> {
  isNew = false;

  deglawyFeaturedId = -1;

  pageTitle = '';

  lastHistory = -1;

  deglawyFeaturedFormTitle = '';

  deglawyFeaturedSchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: { langCode: string; langValue: string }[];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(
    props: IProps & RouteComponentProps,
    isConstructor = true
  ) {
    if (props.match.params.id) {
      this.isNew = false;
      this.deglawyFeaturedId = props.match.params.id;
      this.pageTitle = translate('editDeglawyFeaturedPageTitle', {});
    } else {
      this.isNew = true;
      this.pageTitle = translate('addDeglawyFeaturedPageTitle', {});
    }
    this.initState(isConstructor);
    this.initDeglawyFeaturedSchema();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.dropdownLanguages = this.getDropdownLanguages();
    this.deglawyFeaturedFormTitle = translate(
      'deglawyFeaturedPageFormInfo',
      {}
    );
  }

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      console.log('here', this.props.location);
      this.initializeComponent(nextProps, false);
      this.forceUpdate();
      if (!this.isNew) {
        this.getDeglawyFeatured(this.state.selectedLang);
      }
    }
  }

  initDeglawyFeaturedSchema = () => {
    this.deglawyFeaturedSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      points: Yup.string().required('Required'),
      preview: Yup.string().required('Required'),
      description: Yup.string().required('Required'),
    });
  };

  getFormFields = (): FormField[] => [
    {
      name: 'points',
      label: translate('deglawyFeaturedPageFormPoints', {}),
      type: 'text',
      filedType: 'InputField',
      value: this.isNew
        ? ''
        : `${this.props.deglawyFeaturedStore.selectedDelawyFeatured.getPoints()}`,
    },
    {
      name: 'title',
      label: this.isNew
        ? translate('deglawyFeaturedPageFormArabicTitle', {})
        : translate('deglawyFeaturedPageFormTitle', {}),
      type: 'text',
      filedType: 'InputField',
      value: this.isNew
        ? ''
        : this.props.deglawyFeaturedStore.selectedDelawyFeatured.getTitle(),
    },
    {
      name: 'preview',
      label: this.isNew
        ? translate('deglawyFeaturedPageFormArabicPreview', {})
        : translate('deglawyFeaturedPageFormPreview', {}),
      type: 'text',
      filedType: 'InputField',
      value: this.isNew
        ? ''
        : this.props.deglawyFeaturedStore.selectedDelawyFeatured.getPreview(),
    },
    {
      name: 'description',
      label: this.isNew
        ? translate('deglawyFeaturedPageFormArabicDescription', {})
        : translate('deglawyFeaturedPageFormDescription', {}),
      filedType: 'RichTextField',
      value: this.isNew
        ? null
        : this.parsToJson(
            this.props.deglawyFeaturedStore.selectedDelawyFeatured.getDescription()
          ),
    },
  ];

  parsToJson = (body: string) => {
    try {
      return JSON.parse(body);
    } catch (error) {
      return null;
    }
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      points: '',
      preview: '',
      title: '',
      descrpriton: '',
      processing: false,
      selectedLang: languageCodes.english,
      loading: !this.isNew,
      formFields: this.isNew ? this.getFormFields() : [],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  getDeglawyFeatuedFormValues = (values: any) => {
    const deglawyFeatured = new DeglawyFeatured();
    deglawyFeatured.setTitle(values.title);
    deglawyFeatured.setPoints(values.points);
    deglawyFeatured.setPreview(values.preview);
    deglawyFeatured.setDescription(
      JSON.stringify(convertToRaw(values.description.getCurrentContent()))
    );
    return deglawyFeatured;
  };

  handelSubmit = (values: any): void => {
    this.setState({
      processing: true,
    });
    if (this.isNew) {
      const newDeglawyFeatured = this.getDeglawyFeatuedFormValues(values);
      this.props.deglawyFeaturedStore
        .createDelawyFeatured(newDeglawyFeatured)
        .then((res: any) => {
          this.props.history.push(`${res.data.deglawyFeaturedId}/edit`);
          SnackBarComponent.getInstance().openSnackbar(
            translate('createdMessage', {}),
            8000,
            'success'
          );
        })
        .catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(
            translate('errorMessage', {}),
            8000,
            'error'
          );
        });
    } else {
      const updatedDeglawyFeatured = this.getDeglawyFeatuedFormValues(values);
      this.props.deglawyFeaturedStore
        .updateDelawyFeatured(
          updatedDeglawyFeatured,
          this.deglawyFeaturedId,
          this.state.selectedLang
        )
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(
            translate('updatedMessage', {}),
            8000,
            'success'
          );
          this.props.history.go(this.lastHistory);
        })
        .catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(
            translate('errorMessage', {}),
            8000,
            'error'
          );
        });
    }
  };

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: this.isNew ? 'To Next Language' : 'Save Changes',
    onSubmit: this.handelSubmit,
  });

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getDeglawyFeatured(langCode);
      }
    }
  };

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithDeglawyFeaturedDate = () => {
    const formFieldsWithData = this.getFormFields();
    console.log(formFieldsWithData);
    this.setState({
      formFields: formFieldsWithData,
      loading: false,
    });
  };
  // copied function which take {key, value} and check every key if matching with title so resete to the value and prop it to GeneralFormComponent
  onChangeValues = (key: any, value: any) => {
    //console.log(key, value);
    if (key === 'title') {
      this.setState({ title: value });
    } else if (key === 'points') {
      console.log(value);
      this.setState({ points: value });
    } else if (key === 'preview') {
      this.setState({ preview: value });
    } else if (key === 'description') {
      this.setState({
        descrpriton: draftToHtml(
          convertToRaw(value.getCurrentContent())
        ).replace(/\n/g, '<br>'),
      });
    }
  };
  render() {
    return (
      <div className={classes.featuredContainer}>
        {/* adding a new div and using flexbox to make our divs horizontal flex */}
        <div className={classes.container}>
          <div className={classes.header}>
            <IconButton
              className={classes.backButton}
              onClick={() => this.props.history.goBack()}
              aria-label="Back"
            >
              <KeyboardArrowLeft />
            </IconButton>
            <Typography className={classes.title} variant="h6" gutterBottom>
              {this.pageTitle}
            </Typography>
          </div>
          <div className={classes.content}>
            {this.state.loading ? (
              <Spinner />
            ) : (
              <GeneralFormComponent
                dropdownLanguages={this.dropdownLanguages}
                formTitle={this.deglawyFeaturedFormTitle}
                fields={this.state.formFields}
                formSchema={this.deglawyFeaturedSchema}
                submitButton={this.submitButton}
                cancelButton={this.cancelButton}
                processing={this.state.processing}
                onChangeValues={(key, value) => this.onChangeValues(key, value)}
              />
            )}
          </div>
        </div>
        <div className={classes.deglawyPreview}>
          <DeglawyFeaturedPreview
            title={this.state.title}
            preview={this.state.preview}
            points={this.state.points}
            description={this.state.descrpriton}
          />
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (!this.isNew) {
      this.getDeglawyFeatured(this.state.selectedLang);
    }
  }

  getDeglawyFeatured = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.deglawyFeaturedStore
      .getDelawyFeaturedById(this.deglawyFeaturedId, langCode)
      .then(() => {
        this.updateStateWithDeglawyFeaturedDate();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default withRouter(AddEditDeglawyFeatured);
